const Data = [
  {
    id: 'Básico',
    name: 'Básico',
    quote_text: 'Apartamento Base',
    price: '0',
  },
  {
    id: 'Desmontable',
    name: 'Módulo liviano',
    quote_text: 'Módulo liviano',
    price: '26,000,000',
  },
]

module.exports = { Data };